import * as React from 'react';
import { PriceType } from '../../classes/price-type';
import { CartSeat, Seat, SeatPricing, SeatZone, SeatStyle } from '../../classes/seat';
import isMobile from '../../helpers/is-mobile';

import isEqual from 'react-fast-compare';
import { SeatingOptionGroup } from '../../classes/seating-option';

declare var Modernizr: any;

interface ISeatPathProps {
    key: string;
    seat: Seat;
    selectedSeat: Seat;
    dispatch: any;
    levelPricing: Array<SeatZone>;
    selectedPriceTypes: Array<PriceType>;
    selectedSpecialSeatingFilter: Array<SeatingOptionGroup>;
    lowerPrice: number;
    upperPrice: number;
    mouseOverSeat: (Seats, xPos, yPos) => any;
    mouseOutSeat: (Seats) => any;
    mapDragging: boolean;
    cartSeats: Array<CartSeat>;

    seatStyles: Array<SeatStyle>;
    seatHovered: boolean;
    isTest?: boolean;
    loadedExchangePricing: boolean;
    isExchange: boolean;
}

enum SeatHoverPosition {
    TopLeft,
    TopRight,
    BottomLeft,
    BottomRight
}

class SeatPath extends React.Component<ISeatPathProps, any>{
    constructor(props: ISeatPathProps) {
        super(props);
    }

    shouldComponentUpdate(nextProps: ISeatPathProps, nextState) {
        if (nextProps.mapDragging) {
            return false;
        }
        if (nextProps.isTest != null && nextProps.isTest) {
            return true;
        }
        return !isEqual(this.props, nextProps);
    }

    private getSelectedPrices(props: ISeatPathProps) {
        let seatZone = props.seat.tessituraSeat.zoneId;
        let matchedZone = props.levelPricing.filter(levelPricing => levelPricing.zoneId === seatZone);

        if (matchedZone.length > 0 && matchedZone[0].prices.length > 0) {
            //this means the user did not pick any filters, so no need to match on selected filters
            if (props.selectedPriceTypes.length === 0) {
                return matchedZone[0].prices;
            }
            return matchedZone[0].prices.filter(price => props.selectedPriceTypes.some(selectedPriceType => selectedPriceType.priceTypeId === price.priceTypeId));
        } else {
            return [];
        }
    }

    private isInPriceRange(): boolean {
        if (this.props.isExchange && !this.props.loadedExchangePricing) {
            return true;
        }

        if (this.getSelectedPrices(this.props).length > 0) {
            var ret = this.getSelectedPrices(this.props)
                .some(price => price.price + price.feeAmount >= this.props.lowerPrice
                    && price.price + price.feeAmount <= this.props.upperPrice);
            //if (!ret) {
            //    console.log('price: ' + this.getSelectedPrices(this.props)[0].price);
            //    console.log('low: ' + this.props.lowerPrice);
            //    console.log('high: ' + this.props.upperPrice);
            //}
            return ret;
        } else {
            return false;
        }
    }

    private doesApplyPriceTypeFilter(): boolean {
        return this.props.selectedPriceTypes.length > 0
            ? this.props.selectedPriceTypes.some(pt => this.getSelectedPrices(this.props).map(price => price.priceTypeId).indexOf(pt.priceTypeId) >= 0)
            : true;
    }

    private doesApplySpecialSeatingFilter(): boolean {
        if (this.props.selectedSpecialSeatingFilter.length == 0)
            return true;

        return this.props.selectedSpecialSeatingFilter
            .filter(x => this.props.seat.satisfiedSeatConditionIds.indexOf(x.seatConditionId) >= 0).length > 0;
    }

    private get isInCart(): boolean {
        if (this.props.cartSeats.length === 0)
            return false;
        else {
            var isInCart = this.props.cartSeats.some(cartSeat => cartSeat.seatId === this.props.seat.seatId);
            return isInCart;
        }
    }

    render() {
        var currentSeatStyle = this.props.seat.seatStyle;
        if (this.isInCart) {
            var inCartStyle = this.props.seatStyles.filter(sty => sty.id === this.props.seat.inCartSeatStyleId);
            if (inCartStyle.length > 0) {
                currentSeatStyle = inCartStyle[0];
            }
        }

        //if the current seat is in the cart
        const seatDisabled = this.props.seat.tessituraSeat.isAvailable && this.props.seat.tessituraSeat.isDisabled;

        var selectedSeat = this.props.selectedSeat != null ? this.props.selectedSeat.seatId === this.props.seat.seatId : false;

        var seatFill = selectedSeat ? currentSeatStyle.svgSelectedFill : currentSeatStyle.svgDefaultFill;
        seatFill = this.props.seatHovered && (!seatDisabled)
            && (this.props.seat.tessituraSeat.isAvailable || (this.props.seat.seatStyleCulture.fullPrompt != null && this.props.seat.seatStyleCulture.fullPrompt.length > 0))
            && !isMobile() ? currentSeatStyle.svgHoverFill : seatFill;

        let hasHoverText = (this.props.seat.seatStyleCulture.smallPrompt !== null && this.props.seat.seatStyleCulture.smallPrompt.length > 0)
            || (this.props.seat.tessituraSeat.isAvailable && this.props.seat.seatingOptionGroup != null && this.props.seat.seatingOptionGroup.unlockSeatingOptionGroupId != null);

        let hasPromptText = (this.props.seat.seatStyleCulture.fullPrompt !== null && this.props.seat.seatStyleCulture.fullPrompt.length > 0);

        let isUnAvailableText = ((!this.props.seat.tessituraSeat.isAvailable || this.props.seat.tessituraSeat.isDisabled) ? " is-unavailable" : "");
        let disableCriterMismatchFading = (this.props.seat.tessituraSeat.isAvailable && !selectedSeat && !this.props.seat.suggestedSeat);

        var specialSeatingMismatch = !this.doesApplySpecialSeatingFilter();
        var priceRangeMismatch = !this.isInPriceRange();
        var priceTypeMismatch = !this.doesApplyPriceTypeFilter();

        //if (specialSeatingMismatch) {
        //    console.log("special seating mismatch for " + this.props.seat.tessituraSeat.rowText + this.props.seat.tessituraSeat.numberText);
        //}
        //if (priceRangeMismatch) {
        //    console.log("price range mismatch for " + this.props.seat.tessituraSeat.rowText + this.props.seat.tessituraSeat.numberText);
        //}
        //if (priceTypeMismatch) {
        //    console.log("price type mismatch for " + this.props.seat.tessituraSeat.rowText + this.props.seat.tessituraSeat.numberText);
        //}

        return (
            <path id={'seat-' + this.props.seat.seatId} data-seat-id={this.props.seat.seatId} key={this.props.seat.seatId}
                d={this.isInCart ? this.props.seat.inCartSeatPath : this.props.seat.activeSvgPath} fill={seatFill}
                strokeWidth={currentSeatStyle.svgStrokeWidth}
                stroke={currentSeatStyle.svgStrokeColor}
                className={isUnAvailableText + ((disableCriterMismatchFading && (specialSeatingMismatch
                    || priceRangeMismatch || priceTypeMismatch)) ? " criteria-mismatch" : "")
                    + (hasPromptText ? " has-prompt" : (hasHoverText ? " has-hover" : ""))
                    + " seat-path-js seat-path"}
                onMouseOver={(e) => {
                    //if (!this.props.mapDragging) {
                    let svgPath = e.currentTarget.getBoundingClientRect();
                    let mouseCordsX = e.pageX;
                    let mouseCordsY = e.pageY;
                    this.props.mouseOverSeat([this.props.seat], mouseCordsX, mouseCordsY);
                    //this.props.mouseOverSeat([this.props.seat], svgPath.left + (svgPath.width / 2), svgPath.top + (svgPath.height / 2));
                    //}
                }}
                onMouseOut={(e) => {
                    //if (!this.props.mapDragging) {
                    this.props.mouseOutSeat([this.props.seat])
                    //}
                }} />
        );
    }


}

export default SeatPath;